<tvl-dropdown
  [languages]="languages"
  [selectedLanguage]="selectedLanguage"
  [isSystemSelector]="true"
  [isNotMobile]="!isMobile"
  (onLanguageChange)="changeLanguage($event)"
></tvl-dropdown>
